import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./data/providers/AuthProvider";

import "./App.css";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <AuthProvider>
    <App />
    <div id="printPreview" style={{ display: "none", padding: "8px" }} />
  </AuthProvider>
);
